import React from "react";
// import cx from "classnames";
// import PropTypes from 'prop-types'
import { SelectDropdownStyled } from "./styled";
import { Icons } from "components";
import Dropdown from "react-dropdown"
import "react-dropdown/style.css"

const SelectDropdown = ({
  // theme_standard_select_drop_down,
  label,
  value,
  options = [],
  onChange,
  arrowColor = '#575656',
  errors,
  onChangeCustom,
  placeholder,
  hideBorder,
  heightBox,
  heightMenu,
  maxHeightMenu,
  minHeightMenu,
  widthbox,
  padding,
  borderRadiusSelect,
  topselect,
  disabled,
  ...props
}) => {
  // const customClass = cx({
  //   theme_standard_select_drop_down: theme_standard_select_drop_down,
  // });

  return (
    <SelectDropdownStyled
      hideBorder={hideBorder}
      widthbox={widthbox}
      padding={padding}
      heightBox={heightBox}
      heightMenu={heightMenu}
      disabled={disabled}
      borderRadiusSelect={borderRadiusSelect}
      topselect={topselect}
      errors={errors}
      maxHeightMenu={maxHeightMenu}
      minHeightMenu={minHeightMenu}
    >
      {label && <div className="label">{label}</div>}
      <Dropdown
        {...props}
        disabled={disabled}
        controlClassName="control_input"
        placeholderClassName="input"
        menuClassName="menu_input"
        options={options}
        arrowClosed={
          <span className="arrow-closed">
            <Icons.IconDropdown color={arrowColor} />
          </span>
        }
        arrowOpen={
          <span className="arrow-open">
            <Icons.IconDropdown color={arrowColor} />
          </span>
        }
        onChange={(e) => {
          onChange && onChange(e)
          onChangeCustom && onChangeCustom(e)
        }}
        value={value}
        placeholder={placeholder || "Select an option"}
      />
      {errors && <div className="error_show">{`* ${errors}`}</div>}
    </SelectDropdownStyled>
  );
};

SelectDropdown.propTypes = {};

// audio/* representing sound files.
// video/* representing video files.
// image/* representing image files.

export default SelectDropdown;
